import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import { TABS } from 'FormsUI/constants/FormFieldConfigurationPanel';

// @ts-expect-error untyped dependency
import LogicConfig from './logic/LogicConfigContainer';
// @ts-expect-error untyped dependency
import Base from './fields/Base';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const logicTabStates = {
  ENABLED: 'enabled',
  LOCKED: 'locked',
  HIDDEN: 'hidden'
};
const getLogicTabState = (shouldShowLogicConfig, shouldLockLogicConfig) => {
  if (shouldLockLogicConfig) {
    return logicTabStates.LOCKED;
  }
  if (shouldShowLogicConfig) return logicTabStates.ENABLED;
  return logicTabStates.HIDDEN;
};
const FormFieldConfigurationTabs = ({
  shouldLockLogicConfig,
  shouldShowLogicConfig,
  field,
  onSelectedChange,
  selected = TABS.BASIC
}) => {
  const logicTabState = getLogicTabState(shouldShowLogicConfig, shouldLockLogicConfig);
  const logicTabHidden = logicTabState === logicTabStates.HIDDEN;
  const logicTabDisabled = logicTabState === logicTabStates.LOCKED;
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    paddingBlock: "200",
    paddingInline: "200",
    children: /*#__PURE__*/_jsxs(Tabs, {
      use: "enclosed",
      defaultSelected: selected,
      "data-test-id": "config-editor",
      onSelectedChange: event => onSelectedChange(event.target.value),
      panelStyles: {
        paddingInline: '0',
        marginBlock: '0'
      },
      children: [/*#__PURE__*/_jsx(Tab, {
        "data-test-id": "form-field-configuration-basic-tab",
        tabId: TABS.BASIC,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editor.form.config.tabs.basic"
        }),
        children: /*#__PURE__*/_jsx(View, {
          as: "div",
          "data-test-id": "basic-tab",
          paddingBlockStart: "500",
          children: /*#__PURE__*/_jsx(Base, {})
        })
      }), !logicTabHidden && /*#__PURE__*/_jsx(Tab, {
        "data-test-id": "form-field-configuration-logic-tab",
        tabId: TABS.LOGIC,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editor.form.config.tabs.logic"
        }),
        disabled: logicTabDisabled,
        tooltipProps: {
          placement: 'right'
        },
        children: field && /*#__PURE__*/_jsx(View, {
          as: "div",
          paddingBlockStart: "500",
          children: /*#__PURE__*/_jsx(LogicConfig, {
            formField: field
          })
        })
      })]
    })
  });
};
export default FormFieldConfigurationTabs;